@if (showCart && cart) {
  <div class="tw-flex tw-gap-4 tw-p-4 tw-border tw-border-gray-300 tw-rounded-lg tw-shadow-lg">
    <div class="tw-w-1/2 tw-p-4 tw-border-r tw-border-gray-300">
      <pegasus-customer-cart [cart]="cart" class="tw-bg-white tw-rounded-lg " />
    </div>

    <div class="tw-w-1/2 tw-p-4">
      <pegasus-banner [banners]="halfScreenBanners" class="tw-bg-gray-50 tw-rounded-lg tw-shadow-md" />
    </div>
  </div>
} @else {
  <pegasus-banner [banners]="fullScreenBanners" class="tw-bg-gray-50 tw-rounded-lg tw-shadow-md" />
}
